// Error log types for MoZo.Live error reporting system

export interface ErrorLog {
  id?: string;
  user_id?: string | null;
  error_message: string;
  error_stack?: string | null;
  error_type: string;
  component?: string | null;
  url: string;
  route?: string | null;
  browser_info: BrowserInfo;
  device_info: DeviceInfo;
  app_version: string;
  additional_context?: Record<string, any> | null;
  status: ErrorStatus;
  created_at?: string;
  resolved_at?: string | null;
  resolved_by?: string | null;
  resolution_notes?: string | null;
}

export interface BrowserInfo {
  userAgent: string;
  language: string;
  platform: string;
  vendor: string;
  cookieEnabled: boolean;
}

export interface DeviceInfo {
  screenWidth: number;
  screenHeight: number;
  pixelRatio: number;
  orientation: string;
  connection: ConnectionInfo | 'unknown';
}

export interface ConnectionInfo {
  effectiveType: string;
  downlink: number;
  rtt: number;
  saveData: boolean;
}

export enum ErrorStatus {
  UNRESOLVED = 'unresolved',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  IGNORED = 'ignored'
}

export enum ErrorSeverity {
  FATAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug'
}

export type CreateErrorLogInput = Omit<ErrorLog, 'id' | 'created_at' | 'status' | 'resolved_at' | 'resolved_by' | 'resolution_notes'>;
